import { render, staticRenderFns } from "./KasbonApprovalView.vue?vue&type=template&id=4af61dee"
import script from "./KasbonApprovalView.vue?vue&type=script&lang=js"
export * from "./KasbonApprovalView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports